var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 29.3333C23.3636 29.3333 29.3332 23.3638 29.3332 16C29.3332 8.63616 23.3636 2.66663 15.9998 2.66663C8.63604 2.66663 2.6665 8.63616 2.6665 16C2.6665 23.3638 8.63604 29.3333 15.9998 29.3333ZM15.9998 9.33329C16.7362 9.33329 17.3332 9.93025 17.3332 10.6666V16C17.3332 16.7363 16.7362 17.3333 15.9998 17.3333C15.2635 17.3333 14.6665 16.7363 14.6665 16V10.6666C14.6665 9.93025 15.2635 9.33329 15.9998 9.33329ZM17.3332 21.3333C17.3332 22.0697 16.7362 22.6666 15.9998 22.6666C15.2635 22.6666 14.6665 22.0697 14.6665 21.3333C14.6665 20.5969 15.2635 20 15.9998 20C16.7362 20 17.3332 20.5969 17.3332 21.3333Z",
    fill: "#EB7100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarning);
export default __webpack_public_path__ + "static/media/alert-warning.6fdf06a0175ff1a4219db9d6550f2c22.svg";
export { ForwardRef as ReactComponent };